

module.exports = __webpack_require__.stylable.create(
    "DeliveryMethod1372513102",
    {"classes":{"root":"DeliveryMethod1372513102__root","dropdown":"DeliveryMethod1372513102__dropdown"},"vars":{},"stVars":{"textColor":"'\"color(--cart_textColor)\"'","bodyFont":"'\"font({theme: 'cart_textFontStyle', size: '16px', lineHeight: '1.5'})\"'","backgroundColor":"'\"color(--cart_background)\"'","dropdownBackgroundColor":"rgba(255, 255, 255, 1)","itemTextColor":"#000000","itemDisabledTextColor":"#C7C7C7"},"keyframes":{}},
    "",
    14,
    "DeliveryMethod1372513102",
    null
);
